import { ETH, TokenDetails } from "@config/contractsConfig";
import { useQuery } from "@tanstack/react-query";
import { gql, request } from "graphql-request";
import { useAccount } from "wagmi";
import useDappConfig from "./useDappConfig";
import { TTnxHistory } from "@constants/dapp";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

const ENDPOINT =
  "https://api.thegraph.com/subgraphs/id/Qmc7Js4RqJVjv9fSBf8WnJ2oqUz2ajJkfbkDDgKVACzQGF";

const getTnxQuery = (address: `0x${string}` | undefined) => {
  return gql`
{
  assetWithdrawalFinalizeds(
    where: { withdrawer: "${address}", status:1}
  ) {
    withdrawer
    asset
    amountBurned
    status
    blockTimestamp
    transactionHash
  }
}
`;
};

const fetchTnxHistory = async (address: `0x${string}` | undefined) => {
  const query = getTnxQuery(address);
  const variables = { first: 5 };
  const response: any = await request(ENDPOINT, query, variables);
  return response;
};

const getTimeFromEpoch = (epoch: number) => {
  const d = new Date(0); // The 0 there is the key, which sets the date to the epoch
  d.setUTCSeconds(epoch);
  const zonedDate = utcToZonedTime(d, "UTC");
  return format(zonedDate, "do MMM yy hh:mm a 'UTC'");
};

const useTransactionHistory = () => {
  const { address } = useAccount();
  const { config } = useDappConfig();

  const tokensObj = {
    ...config.tokens,
    [ETH]: config.nativeToken as any,
  } as TokenDetails;
  const tokens = Object.entries(tokensObj).reduce<TokenDetails>(
    (acc, token) => {
      acc[token[1].address.toLowerCase()] = token[1];
      return acc;
    },
    {}
  );

  const { data, isFetching } = useQuery({
    queryKey: ["tnxHistory", address],
    queryFn: () => fetchTnxHistory(address),
  });

  const fetchedData = <TTnxHistory[]>data?.["assetWithdrawalFinalizeds"];

  const formattedData: TTnxHistory[] = [];
  if (data?.["assetWithdrawalFinalizeds"]) {
    fetchedData.forEach((record) => {
      formattedData.push({
        ...record,
        asset: tokens[record?.asset.toLowerCase()]?.symbol,
        blockTimestamp: getTimeFromEpoch(Number(record?.blockTimestamp)),
      });
    });
  }

  tokens;
  return {
    completedWithdrawals: formattedData,
    isFetching,
  };
};

export default useTransactionHistory;
